module.exports = __webpack_public_path__ + "static/media/max-pink.2c5f9af9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/max-pink.png
// module id = 2060
// module chunks = 0